export default class HistoricalLoadSerializer {
  static serialize(data) {
    return data;
  }

  static deSerialize(data) {
    return {
      id: data.orderId,
      mode: data.revenueCodeId,
      originCity: data.originCity,
      originState: data.originState,
      origSchedArriveEarly: data.origSchedArriveEarly,
      origSchedArriveLate: data.origSchedArriveLate,
      originActual: data.pickupActual,
      destinationCity: data.destinationCity,
      destinationState: data.destinationState,
      destSchedArriveEarly: data.destSchedArriveEarly,
      destSchedArriveLate: data.destSchedArriveLate,
      destinationActual: data.destinationActual,
      customer: data.customerName,
      customerLineHaul: data.customerLineHaul,
      carrierLineHaul: data.carrierLineHaul,
      carrierFuelCost: data.carrierFuelCost,
      carrierTotalPay: data.carrierTotalPay,
      minTemp: data.minTemp,
      maxTemp: data.maxTemp,
      minMaxTemp: data.minTemp && data.maxTemp ? `${data.minTemp}/${data.maxTemp}` : null,
      dispatcherUserId: data.dispatcherUserId,
      brokerageStatus: data.brokerageStatus,
      ...data
    };
  }
}